enum Orientation {
  N = "N",
  E = "E",
  W = "W",
  S = "S",
}

export default Orientation